import React from "react";

import Nav from "./Nav";

function Header() {
  return (
    <header>
      <Nav />
    </header>
  );
}

export default Header;
